export interface HrRosterDashboard {
  owningCompanyId?: number;
  draftPlans?: number;
  publishedPlans?: number;
  openConflicts?: number;
  assignmentsThisWeek?: number;
  plans?: HrRosterPlan[];
  conflicts?: HrRosterConflict[];
}

export interface HrShiftTemplate {
  shiftTemplateId?: number;
  owningCompanyId?: number;
  templateCode?: string;
  templateName?: string;
  assignmentType?: string;
  workerCategory?: string;
  startTime?: string;
  endTime?: string;
  breakMinutes?: number;
  paidHours?: number;
  requiredSkillCode?: string;
  colorCode?: string;
  active?: boolean;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrEmployeeWorkPattern {
  workPatternId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  shiftTemplateId?: number;
  shiftTemplateName?: string;
  dayOfWeek?: number;
  assignmentType?: string;
  startTime?: string;
  endTime?: string;
  breakMinutes?: number;
  plannedHours?: number;
  requiredSkillCode?: string;
  locationName?: string;
  effectiveFrom?: string;
  effectiveUntil?: string;
  active?: boolean;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrGenerateRosterFromPatternsRequest {
  owningCompanyId?: number;
  employeeId?: number;
}

export interface HrRosterPlan {
  rosterPlanId?: number;
  owningCompanyId?: number;
  planCode?: string;
  planName?: string;
  planStatus?: string;
  periodStart?: string;
  periodEnd?: string;
  businessUnit?: string;
  notes?: string;
  publishedAt?: string;
  publishedByCustomerId?: number;
  unpublishedAt?: string;
  unpublishedByCustomerId?: number;
  createdByCustomerId?: number;
  createdAt?: string;
  updatedAt?: string;
  assignmentCount?: number;
  openConflictCount?: number;
}

export interface HrCoverageRequirement {
  coverageRequirementId?: number;
  owningCompanyId?: number;
  rosterPlanId?: number;
  requirementDate?: string;
  assignmentType?: string;
  workerCategory?: string;
  requiredSkillCode?: string;
  requiredCount?: number;
  startTime?: string;
  endTime?: string;
  locationName?: string;
  notes?: string;
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrRosterAssignment {
  rosterAssignmentId?: number;
  owningCompanyId?: number;
  rosterPlanId?: number;
  sourceWorkPatternId?: number;
  shiftTemplateId?: number;
  shiftTemplateName?: string;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  assignmentType?: string;
  assignmentStatus?: string;
  workDate?: string;
  startTime?: string;
  endTime?: string;
  breakMinutes?: number;
  plannedHours?: number;
  requiredSkillCode?: string;
  locationName?: string;
  shipmentId?: number;
  deliveryId?: number;
  vehicleId?: number;
  mobilizationId?: number;
  warehouseId?: number;
  clearanceAssignmentId?: number;
  projectId?: number;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrRosterConflict {
  rosterConflictId?: number;
  owningCompanyId?: number;
  rosterPlanId?: number;
  rosterAssignmentId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  conflictType?: string;
  severity?: string;
  conflictStatus?: string;
  description?: string;
  readinessSnapshotId?: number;
  detectedAt?: string;
  resolvedAt?: string;
  resolvedByCustomerId?: number;
  resolutionNotes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrRosterChangeLog {
  rosterChangeLogId?: number;
  owningCompanyId?: number;
  rosterPlanId?: number;
  rosterAssignmentId?: number;
  changeType?: string;
  summary?: string;
  details?: string;
  createdByCustomerId?: number;
  createdAt?: string;
}

export const HR_ROSTER_PLAN_STATUSES = ['DRAFT', 'PUBLISHED', 'UNPUBLISHED', 'ARCHIVED'];

export const HR_ROSTER_ASSIGNMENT_STATUSES = ['DRAFT', 'PUBLISHED', 'CANCELLED'];

export const HR_ROSTER_ASSIGNMENT_TYPES = ['GENERAL', 'SHIPMENT_DELIVERY', 'FLEET_MOBILIZATION', 'WAREHOUSE_SHIFT', 'CLEARANCE_ASSIGNMENT', 'POSM_PROJECT', 'OFFICE_SHIFT'];

export const HR_ROSTER_CONFLICT_SEVERITIES = ['BLOCKER', 'WARN'];

export const HR_WEEKDAYS = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 7, label: 'Sunday' }
];

